module.exports = __webpack_public_path__ + "img/thermometer-three-quarters.99a90269.svg";